import { render, staticRenderFns } from "./SecondaryNav.vue?vue&type=template&id=8b90feb2&"
import script from "./SecondaryNav.vue?vue&type=script&lang=ts&"
export * from "./SecondaryNav.vue?vue&type=script&lang=ts&"
import style0 from "./SecondaryNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavigationLink: require('/tmp/build_453bf6d7/src/components/navigation/NavigationLink.vue').default,Button: require('/tmp/build_453bf6d7/src/components/button/Button.vue').default,AnimateExpand: require('/tmp/build_453bf6d7/src/components/animate/AnimateExpand.vue').default})
